<template>
  <div class="head">
    <img src="@/assets/index/joinParty/dp-lc-bg.png" alt />
    <p>{{title}}</p>
    <button @click="goBack">返回上级</button>
  </div>
</template>
<script>
export default {
  name: "joinHead",
  props: {
    title: String
  },
  methods: {
    goBack() {
      if (this.$parent.shows != 0) this.$parent.shows = 0;
       else this.$router.go(-1);
    }
  }
};
</script>
<style lang='scss' scoped>
.head {
  button {
    padding: 0.1rem 0.2rem;
    color: #ffffff;
    font-size: 0.32rem;
    background-image: linear-gradient(90deg, #fb8d72 0%, #ea5e63 100%);
    border-radius: 0.04rem;
    border: 0;
    position: absolute;
    right: 0.5rem;
    top: 0.7rem;
  }
  p {
    position: absolute;
    bottom: 1.1rem;
    font-size: 0.36rem;
    font-weight: bold;
    color: #fff;
    left: 1.4rem;
  }
  img {
    width: 100%;
    height: 4.56rem;
  }
  position: relative;
}
</style>